<template>
    <div class="waba-supsis-template-category-update">
        <div class="title">{{ $t("auto.whatsappBusinessApiV2TemplateCategoryUpdated") }}</div>
        <div class="meta">
            <div><b>{{ $t("auto.channelId") }}</b>: {{ $_.get(activity, "payload.channelId") }}</div>
            <div><b>{{ $t("auto.templateName") }}</b>: {{ $_.get(activity, "payload.message_template_name") }}</div>
            <div><b>{{ $t("auto.templateId") }}</b>: {{ $_.get(activity, "payload.message_template_id") }}</div>
            <div><b>{{ $t("auto.language") }}</b>: {{ $_.get(activity, "payload.message_template_language") }}</div>
            <div v-if="$_.get(activity, 'payload.previous_category')">
                <b>{{ $t("auto.previousCategory") }}</b>: {{ $_.get(activity, "payload.previous_category") }}
            </div>
            <div v-if="$_.get(activity, 'payload.new_category')">
                <b>{{ $t("auto.newCategory") }}</b>: {{ $_.get(activity, "payload.new_category") }}
            </div>
            <div v-if="$_.get(activity, 'payload.correct_category')">
                <b>{{ $t("auto.correctCategory") }}</b>: {{ $_.get(activity, "payload.correct_category") }}
            </div>
            <div v-if="$_.get(activity, 'payload.category_update_timestamp')">
                <b>{{ $t("auto.updateTime") }}</b>: {{ formatTimestamp($_.get(activity, "payload.category_update_timestamp")) }}
            </div>
        </div>
        <details class="raw">
            <summary>{{ $t("auto.rawPayload") }}</summary>
            <pre>{{ prettyPayload }}</pre>
        </details>
    </div>
</template>
<script>
import Vue from "vue";
import moment from "moment";

export default Vue.extend({
    name: "WabaSupsisTemplateCategoryUpdate",
    props: {
        activity: {
            type: Object,
            default: () => ({}),
        },
    },
    computed: {
        prettyPayload() {
            try {
                return JSON.stringify(this.$_.get(this.activity, "payload", {}), null, 2);
            } catch (e) {
                return String(this.$_.get(this.activity, "payload", ""));
            }
        },
    },
    methods: {
        formatTimestamp(timestamp) {
            if (!timestamp) return "";
            return moment.unix(timestamp).format("DD.MM.YYYY HH:mm:ss");
        },
    },
});
</script>

<style scoped lang="scss">
.waba-supsis-template-category-update {
    .title {
        font-weight: 600;
        margin-bottom: 6px;
    }
    .meta {
        display: flex;
        flex-direction: column;
        gap: 2px;
        margin-bottom: 8px;
    }
    .raw {
        pre {
            max-height: 240px;
            overflow: auto;
            padding: 10px;
            border: 1px solid var(--color-border-default);
            border-radius: 6px;
            background: var(--color-bg-neutral-default);
        }
        summary {
            cursor: pointer;
            user-select: none;
            margin-bottom: 6px;
        }
    }
}
</style>
